// extracted by mini-css-extract-plugin
export default {"text":"TextParagraph_text__ihnGA"};